module.exports = __webpack_public_path__ + "img/SG.41eabfc1.jpg";